import { ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';
import { bookingsUoUFlowBookInitialIntentSrc16Evid33 } from '@wix/bi-logger-bookings-data/v2';
import { bookingsLoginUserAccountSeeAllServicesClick } from '@wix/bi-logger-wixboost-ugc/v2';
import { isBookFlowSettingsEnabled } from '@wix/bookings-calendar-catalog-viewer-mapper';
import { GUID } from '@wix/bi-logger-wixboost-ugc/v2/types';
import {
  navigateToBookingsCalendarPage,
  navigateToCalendarPage,
} from '@wix/bookings-catalog-calendar-viewer-navigation';
import { ExperimentsConsts } from '../../consts/experiments';
import { settingsDefaults, widgetDefaults } from '../../core/bi/consts';
import { BookingsGroup, MemberAreaClickActions } from '../../types';
import { getBasket } from '../../utils/mappers/bookings-mapper/bookings-mapper';
import { CreateActionParams } from '../actions';

export type ClickOnBookAgain = (args: { group: BookingsGroup }) => void;

export function createClickOnBookAgainAction({
  getControllerState,
  context,
}: CreateActionParams): ClickOnBookAgain {
  return async ({ group }) => {
    const { flowAPI, biLogger } = context;
    const { wixCodeApi, platformAPIs } = flowAPI.controllerConfig;
    const [state] = getControllerState();
    const service = group.bookings[0].service;
    const slug = service?.mainSlug?.name;
    const isAppointmentWithAddOns =
      flowAPI.experiments.enabled(ExperimentsConsts.AddonsUOU) &&
      service?.type === ServiceType.APPOINTMENT &&
      !!service?.addOnDetails?.length;

    const serviceType =
      service?.type === ServiceType.APPOINTMENT ? 'ind' : 'class';

    biLogger?.report(
      bookingsLoginUserAccountSeeAllServicesClick({
        extraInfo: JSON.stringify({
          type: serviceType,
        }),
        action: MemberAreaClickActions.BookAgain,
        referralInfo: state.selectedTab.type,
      }),
    );

    biLogger?.report(
      bookingsUoUFlowBookInitialIntentSrc16Evid33({
        widget_name: widgetDefaults.widget_מame,
        serviceType,
        bookingsServiceId: service?.id as GUID,
      }),
    );

    try {
      if (
        isBookFlowSettingsEnabled({
          experiments: flowAPI.experiments,
          bookingsSettings: state.businessInfo?.bookingsSettings,
        })
      ) {
        await navigateToCalendarPage(wixCodeApi, platformAPIs as any, {
          serviceSlugOrBasket: isAppointmentWithAddOns
            ? getBasket({ service })
            : slug,
          navigationContext: {
            referral: settingsDefaults.referralInfo,
          },
        });
      } else {
        await navigateToBookingsCalendarPage(wixCodeApi, platformAPIs as any, {
          serviceSlugOrBasket: isAppointmentWithAddOns
            ? getBasket({ service })
            : slug,
          navigationContext: {
            referral: settingsDefaults.referralInfo,
            autoOpenPreferencesModal: isAppointmentWithAddOns
              ? true
              : undefined,
          },
        });
      }
    } catch {
      wixCodeApi.location.to?.('/');
    }
  };
}
